'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
  ContentfulService:

  Leveraging the ability to create components in the pug file, this component gets contentful 
  resources from the old app space - "pages" model to be specific. This component is 
  useful for when a page view has already occupied the contetnful attributes.

  The component has a productPageMapper which uses the modelKey key to map
  to the contentful "page" reference key. 
  
  It then builds the contentful data into resources in our
  content model. MOST OF THIS CODE IS from PortalPresenter with slight variation.

  This component also has a `contentLoadedPromise` that can be used as a on complete reference.

  As of 2021 May, thie contenfulService is used in Referral Share Bar and it's created in
  educational-template.pug.

  NOTE: Augment this service to be utilize with other contentful model_names and id's

  params (Required):
    [data-mogo-ui-model-key]: model key , usually the product key
    [data-mogo-ui-content-type]: 'page'
*/

function ContentfulService() {
  this.id = null;
  this.node = null;
  this.extends = [];
  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;

  this.productPageMapper = {
    creditscore: 'DashboardCreditScore',
    spend: 'DashboardCard',
    wealth: 'DashboardWealth',
    money: 'DashboardLoans',
    verifyAccount: 'VerifyAccount'
  };
  // Required
  this.modelKey = null;
  this.contentType = null;

  this.contentLoadedPromise = $.Deferred(); // Promise can be used for reference for parent component
  this.contentfulData = null;
  this.contentRef = null; // New Contentful Space with MoneyUp resources
  this.legacyContentRef = null; // Old App Space

  this.init = function () {
    var _this = this;

    var formattedId = this.modelKey.replaceAll('-', '');
    this.contentId = this.productPageMapper[formattedId]; // Contentful Entry Id
    this.contentRef = 'content.' + this.contentType + '.' + this.contentId;
    this.legacyContentRef = 'content.pages.' + this.contentId;

    if (!this._hasContentfulData()) {
      this._loadContentful();
    }

    $.when(this.contentLoadedPromise).done(function () {
      _this.node.style.display = 'block'; // displays the child element on complete
    });
  };

  this.initAllReady = function () {};

  /*
    _hasContentfulData: Check if data is cached in our models 
   */
  this._hasContentfulData = function () {
    return this.contentType && this.contentId && typeof this.presenter.getModelProperty(this.contentRef) !== 'undefined';
  };

  /*
    _loadContentful: Uses contentful api wrapper to retreive contents;
    depending if it's page or not, we have different accesstoken, configs for each space
  */
  this._loadContentful = function () {
    // Legacy Space ("Mogo" snapshot folder) or App System ("master" snapshot folder):
    var environmentId = this.contentType === 'page' ? ContentfulSpaceParams.environment_id : ContentfulAppSpaceParams.environment_id;
    var queryType = this.contentType === 'page' ? 'ENTRIES_FROM_MODEL_BY_NAME' : 'ENTRIES_FROM_MODEL_BY_ID';

    this.contentfulData = new StaticContentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, {
      environment_id: environmentId,
      verboseLevel: 1
    }));

    this.contentfulData.getResource(queryType, {
      model_id: this.contentType,
      name_value: this.contentId
    }, this._onLoadContentfulData.bind(this));
  };

  this._onLoadContentfulData = function (data) {
    if (!this.presenter.models.content) {
      this.presenter.createModel('content', {
        data: {}
      });
    }

    if (data && _typeof(data.items) === 'object' && data.items.length) {
      var contentTree = this._buildContentTree(data.items[0]);
    } else {
      this.presenter.setModelProperty(this.contentRef, {});
    }

    this.contentLoadedPromise.resolve();

    if (this._DEBUG) {
      console.log('set ' + $(container)[0].classList[0] + ' to contentful [' + contentId + '] abort');
    }
  };

  /*
    _buildContentTree: builds an object from the contentful data in to key value pairs.
    this pattern is legacy. IE content: { dashboardLoans: { media1: something }
  */
  this._buildContentTree = function (contentfulNode) {
    var node = {};

    for (var childName in contentfulNode) {
      if (contentfulNode.hasOwnProperty(childName) && childName.charAt('0') !== '_') {
        var childNode = contentfulNode[childName];
        if (childNode instanceof Array && childNode.length) {
          for (var i = 0; i < childNode.length; i++) {
            var list = childNode[i];
            if (list.name || list.key) {
              node[list.name || list.key] = this._buildContentTree(list);
            }
          }
        } else {
          node[childName] = childNode;
        }
      }
    }

    this._setContentTreeModel(node);
    return node;
  };

  /*
    _setContentTreeModel: sets model property depending if it's old/new contentful space.
    the structure of the model needs to be precise for legacy code to work
  */
  this._setContentTreeModel = function (node) {
    if (this.contentType === 'page') {
      this.presenter.setModelProperty(this.legacyContentRef, node); // 'pages' instead of 'page' (backwards compat)
    } else {
      this.presenter.setModelProperty(this.contentRef, node);
    }
  };

  this.destroy = function () {};
}